export enum ChatEvents
{
    CHAT_CHANGE = "on_chat_change",
    MESSAGE_CHANGE = "on_message_change",
    CONTACT_CHANGE = "on_contact_change",
    STATUS_CHANGE = "on_status_change",
    MESSAGE_UNREAD = "on_message_unread",
}

export enum MessageTypes
{
    DIRECT = "d",
    LOST_CALL = "lc",
    FINALIZED_CALL = "fl",
    REJECTED_CALL = "rc"
}

export enum UserStatus
{
    CONNECTED = "connected",
    DISCONNECTED = "disconnected"
}

export enum Roles
{
    // OWNER = "owner",
    // ADMIN = "admin",
    MEMBER = "member"
}

export enum PlatformRole{
    PR = "PR",
    PA = "PA"
}

export interface IMessage
{
    id?: string,
    username: string,
    chatId: string,
    type: MessageTypes,
    callData?: {
        start: string,
        finalized: string,
        originUsername: string
    },
    date?: string,
    message: IMessageContent,
    // attachments?: []
}

export interface IUnreadMessages
{
    id: string,
    chatId: string,
    combined: string,
    messageId: string,
    userId: string
}

export interface IMessageContent
{
    // Hacer opcional si es que se agrega
    // soporte de multimedia
    text: string
}

export interface IContact
{
    id: string,
    username: string,
    name: string,
    email: string,
    isDependent: boolean,
    // status?: UserStatus,
    platformRole: PlatformRole
    chatId?: string
}
export interface INewChat
{
    scope: string,
    type: string,
    value: string
}
export interface IChat
{
    id?: string,
    contacts: string[],
    date: string,
    lastMessage?: IMessage,
    unread?: number
}

export interface IChatCustom extends IChat
{
    contactsFull?: IContact[]
}

export interface IContactRole
{
    contact: string | IContact,
    role: Roles
}

export interface IBaseId
{
    id: string
}

export interface IRequest
{
    auth?: IAuth,
    contact?: IContact,
    contacts?: IContact[] | IBaseId[] | string[],
    chat?: IChat,
    chatId?: string,
    contactId?: string,
    messageId?: string,
    message?: IMessage,
    avoidListening?: boolean,
    listen?: boolean,
    limit?: number,
    type?: PlatformRole,
    loadRich?: boolean,
    patientParams?: IUsersListParams,
    status?: UserStatus,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    search?: string | IContact[] | any[],
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any
}
export interface IStatus
{
    id: string,
    status: UserStatus,
    lastChange: string
}

export interface IAuth
{
    token: string
}

export interface IPatientsParams
{
    currentDate?: string,
    lang?: string,
    timezone?: string
}

/**
 * @deprecated
 */
export interface IUsersListParams
{
    filter: "IN" | "BOTH" | "NOT",
    page: number,
    roleCode: "PA_PLUS",
    size: number,
    usernamePractitioner: string
    organizationId?: number
    appOrigin?: string
}

export interface ILoadPractitionerPatients
{
    practitionerId: string,
    appOrigin?: string
}

export interface IResponse<T>
{
    error?: string,
    error_code?: string,
    data?: T
}

export interface IHandlers
{
    onConnected: (initial: boolean) => void,
    onChatChange: (args: IhandlerType<IChat>) => void,
    onMessageChange: (args: IhandlerType<IMessage>) => void,
    onContactChange: (args: IhandlerType<IContact>) => void,
    onStatusChange: (args: IhandlerType<IStatus>) => void,
    onUnreadMessages: (args: IhandlerType<IUnreadMessages>) => void
}

export interface IhandlerType<T> 
{
    type: string,
    data: T
}

export interface IConnectionArgs
{
    loginAvailable: boolean,
    initial?: boolean
}
